import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const TrashSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.45898 6.20813H5.45898H21.459'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.45898 6.20813V4.20813C8.45898 3.6777 8.6697 3.16899 9.04477 2.79392C9.41984 2.41884 9.92855 2.20813 10.459 2.20813H14.459C14.9894 2.20813 15.4981 2.41884 15.8732 2.79392C16.2483 3.16899 16.459 3.6777 16.459 4.20813V6.20813M19.459 6.20813V20.2081C19.459 20.7386 19.2483 21.2473 18.8732 21.6223C18.4981 21.9974 17.9894 22.2081 17.459 22.2081H7.45898C6.92855 22.2081 6.41984 21.9974 6.04477 21.6223C5.6697 21.2473 5.45898 20.7386 5.45898 20.2081V6.20813H19.459Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.459 11.2081V17.2081'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.459 11.2081V17.2081'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const TrashIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TrashSvg} {...props} />
);
